import type { Currency } from '@fiverr-private/currencies_plugin';

export const HIGH_BUDGET_THRESHOLD_DOLLARS = 500;

export const defaultCurrency: Currency = {
    name: 'USD',
    rate: 1,
    forceRound: false,
    forceRoundFromAmount: 1000,
    // eslint-disable-next-line no-template-curly-in-string
    template: '${{amount}}',
    symbol: '$',
};
